import React from "react";
import "./ServiceItems.css";
import useScrollReveal from "../../hooks/useScrollReveal";
import {
  Cloud,
  Globe,
  Smartphone,
  BarChart3,
  GitBranch,
  Palette,
} from "lucide-react";

const services = [
  {
    name: "Cloud & Infrastructure",
    icon: Cloud,
    description:
      "Design, build, and manage secure, scalable cloud infrastructure across AWS, Google Cloud, and Azure. From architecture consulting to migration and optimization.",
    techs: ["AWS", "Google Cloud", "Azure", "Terraform", "CloudFormation"],
  },
  {
    name: "Web Application Development",
    icon: Globe,
    description:
      "Full-stack web applications built with modern frameworks. Server-rendered, statically generated, or SPA — we choose the right architecture for your product.",
    techs: ["React", "Next.js", "Node.js", "TypeScript", "Python"],
  },
  {
    name: "Mobile Development",
    icon: Smartphone,
    description:
      "Cross-platform and native mobile applications that perform. Shared codebases for speed, native modules for performance-critical features.",
    techs: ["React Native", "Flutter", "iOS", "Android"],
  },
  {
    name: "Data Engineering & Analytics",
    icon: BarChart3,
    description:
      "Data pipelines, real-time processing, and analytics platforms that turn raw data into business decisions. From ETL to machine learning inference.",
    techs: ["Apache Spark", "Python", "PostgreSQL", "Redis", "MongoDB"],
  },
  {
    name: "DevOps & CI/CD",
    icon: GitBranch,
    description:
      "Automated deployment pipelines, infrastructure-as-code, container orchestration, and monitoring. Ship confidently, multiple times per day.",
    techs: ["Docker", "Kubernetes", "GitHub Actions", "Terraform", "Prometheus"],
  },
  {
    name: "UI/UX Design",
    icon: Palette,
    description:
      "Developer-ready interfaces designed for implementation. Design systems, prototypes, and user research that translate directly into production code.",
    techs: ["Figma", "Design Systems", "Prototyping"],
  },
];

export default function ServiceItems() {
  const ref = useScrollReveal();

  return (
    <div ref={ref} className="services-grid reveal">
      {services.map((service, idx) => {
        const Icon = service.icon;
        return (
          <div className={`service-card reveal-delay-${idx % 3}`} key={idx}>
            <div className="service-card-icon">
              <Icon size={28} strokeWidth={1.5} />
            </div>
            <h3 className="service-card-name">{service.name}</h3>
            <p className="service-card-desc">{service.description}</p>
            <div className="tech-badges">
              {service.techs.map((tech) => (
                <span className="tech-badge" key={tech}>
                  {tech}
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
